import { render, staticRenderFns } from "./DepositSlipTemplate.vue?vue&type=template&id=0cf11b3d&scoped=true"
import script from "./DepositSlipTemplate.vue?vue&type=script&lang=js"
export * from "./DepositSlipTemplate.vue?vue&type=script&lang=js"
import style0 from "./DepositSlipTemplate.vue?vue&type=style&index=0&id=0cf11b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf11b3d",
  null
  
)

export default component.exports